/* eslint class-methods-use-this: 0 */

import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { ColumnDefinition } from '@interfaces/central-monitoring';

enum GridColumns {
    ActivityTypeDescription = 'activity_type_description',
    SiteName = 'site_name',
    SubjectNumber = 'subject_number',
    Message = 'message',
    UserName = 'user_name',
    Date = 'date',
    ObservationId = 'observation_id',
    Observation = 'observation',
    ReviewId = 'review_id',
    BulkOperationSubjectCount = 'subjects_count',
}

export class SubjectReviewActivityLogGridHelper implements IGridHelper {
    private _customCells: CustomCells;

    constructor(private customCells: CustomCells) {
        this._customCells = customCells;
    }

    getDisplayFields(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case GridColumns.Date:
            case GridColumns.ActivityTypeDescription:
            case GridColumns.SubjectNumber:
            case GridColumns.UserName:
            case GridColumns.Message:
            case GridColumns.Observation:
                return true;
            default:
                return false;
        }
    }

    getActiveField(columnType: ColumnDefinition): string | undefined {
        switch (columnType.dataField) {
            default:
                return undefined;
        }
    }

    getDisplayTooltipFields(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case GridColumns.Observation:
                return true;
            default:
                return false;
        }
    }

    isRagColumn(): boolean {
        return false;
    }

    multiValueFilter(): boolean {
        return false;
    }

    disableLock(): boolean {
        return false;
    }

    columnWidths: Map<string | null | undefined, number> = new Map([
        [GridColumns.ActivityTypeDescription, 110],
        [GridColumns.SiteName, 115],
        [GridColumns.SubjectNumber, 115],
        [GridColumns.Observation, 115],
        [GridColumns.ObservationId, 225],
        [GridColumns.Message, 200],
        [GridColumns.UserName, 150],
        [GridColumns.Date, 150],
        [GridColumns.ReviewId, 115],
        [GridColumns.BulkOperationSubjectCount, 115],
    ]);

    getColumnWidth(columnType: ColumnDefinition): number | undefined {
        return this.columnWidths.get(columnType.dataField);
    }

    getCustomCell() {
        return undefined;
    }

    disableAdvancedFilter(): boolean {
        return false;
    }
}
